import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import { dot, vosmosLogo1, vosmosLogo2 } from "../assets/img";
import { useDispatch, useSelector } from "react-redux";
import ProgressiveImage from "rc-progressive-image";
import { Box, Button, Fab, ListItemIcon } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import { useApi } from "../hooks";
import { apiLogutUser, method } from "../apiPath";
import { getToast } from "../common/utils";
import keyNames from "../keyName";
import { useNavigate } from "react-router-dom";

const toast = getToast("error");
const Header = ({ open, setOpen }) => {
  const storeData = useSelector((state) => state.mainReducer);
  const { themeMode } = storeData;
  const navigate = useNavigate();
  const dispatch = useDispatch;
  const hitApi = useApi();
  const [anchorEl, setAnchorEl] = useState(null);
  const show = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (path) => {
    if (path) navigate(path);
    setAnchorEl(null);
  };
  const logOut = async () => {
    const res = await hitApi(
      apiLogutUser,
      null,
      method.post,
      keyNames.userData,
      toast
    );
    if (res?.status === 200) {
      navigate("/"); // Redirect to login page
    }
  };
  // const logOut = () => {
  //   hitApi(apiLogutUser, null, method.post, keyNames.userData);
  // };
  // const logOut = async () => {
  //   const res = await hitApi(
  //     apiLogutUser,
  //     null,
  //     method.post,
  //     keyNames.userData,
  //     toast
  //   );
  //   if (res?.status === 200) {
  //     // Clear user data from store
  //     dispatch({ type: "CLEAR_USER_DATA" }); // Make sure you have this action
  //     navigate("/", { replace: true }); // Force replace in history
  //   }
  // };

  return (
    <AppBar position="fixed" color="transparent" elevation={0}>
      <Toolbar
        sx={{ paddingLeft: "16px !important", paddingRight: "16px !important" }}
      >
        <Button
          variant=""
          sx={{
            mr: 2,
            p: 0.7,
            minWidth: "auto",
          }}
          onClick={() => setOpen(!open)}
        >
          <MenuIcon />
        </Button>
        <Box sx={{ flexGrow: 1 }}>
          <Box className="logo">
            <Link to="/app">
              <ProgressiveImage
                src={themeMode === "light" ? vosmosLogo1 : vosmosLogo2}
                placeholder={dot}
                errorImage={dot}
                alt="Vosmos Forms"
              />
            </Link>
          </Box>
        </Box>

        <Fab
          size="small"
          color="primary"
          aria-label="profile"
          onClick={handleClick}
        >
          <AccountCircle />
        </Fab>

        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          open={show}
          onClose={() => handleClose()}
          sx={{ mt: 1.5 }}
          MenuListProps={{ sx: { minWidth: 150 } }}
        >
          <MenuItem sx={{ py: 1.5 }} onClick={() => handleClose("user-profile")}>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            Profile
          </MenuItem>
          <MenuItem sx={{ py: 1.5 }} onClick={logOut}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
